var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPuce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#4C54F3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1339",
    className: "st0",
    d: "M-0.5-0.5h33v33h-33V-0.5z M-0.5-0.5h33v33h-33V-0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1340",
    className: "st1",
    d: "M22.3,9.9L13.2,19l-4.9-4.9L6.4,16l6.9,6.9l11-11L22.3,9.9z M16,2.2C8.4,2.2,2.2,8.4,2.2,16 S8.4,29.8,16,29.8S29.8,23.6,29.8,16C29.7,8.4,23.6,2.3,16,2.2z M16,27C9.9,27,5,22.1,5,16S9.9,5,16,5s11,4.9,11,11S22.1,27,16,27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPuce);
export default __webpack_public_path__ + "static/media/_icon_puce.115e6b3926e862a4d95b72149b5577af.svg";
export { ForwardRef as ReactComponent };